import { format, isValid, parse } from 'date-fns';

export type DateTimeVariant = 'date' | 'time' | 'datetime' | 'month';

/* The wire format is what gets stored in the form response and what min/max
   arrive as. It matches what the native inputs used to produce, so saved
   responses keep working — do not change these. */
const WIRE_FORMAT: Record<DateTimeVariant, string> = {
  date: 'yyyy-MM-dd',
  time: 'HH:mm',
  datetime: "yyyy-MM-dd'T'HH:mm",
  month: 'yyyy-MM',
};

const DISPLAY_FORMAT: Record<DateTimeVariant, string> = {
  date: 'dd MMM yyyy',
  time: 'hh:mm a',
  datetime: 'dd MMM yyyy, hh:mm a',
  month: 'MMM yyyy',
};

export const DISPLAY_PLACEHOLDER: Record<DateTimeVariant, string> = {
  date: 'DD MMM YYYY',
  time: 'HH:MM',
  datetime: 'DD MMM YYYY, HH:MM',
  month: 'MMM YYYY',
};

/* Every parse goes through date-fns with an explicit format against a local
   reference date. `new Date(str)` and `parseISO` would treat a bare date as
   UTC and shift it a day either side of the date line. */
export const parseValue = (
  raw: string | undefined | null,
  variant: DateTimeVariant,
): Date | null => {
  if (!raw) return null;
  const parsed = parse(raw, WIRE_FORMAT[variant], new Date());
  return isValid(parsed) ? parsed : null;
};

export const formatWire = (date: Date, variant: DateTimeVariant): string =>
  format(date, WIRE_FORMAT[variant]);

export const formatDisplay = (
  raw: string | undefined | null,
  variant: DateTimeVariant,
): string => {
  const parsed = parseValue(raw, variant);
  return parsed ? format(parsed, DISPLAY_FORMAT[variant]) : '';
};
